module.exports = __webpack_public_path__ + "img/img21.08cd2f76.png";